import { Injectable } from '@angular/core';
import {
  VesselHotoForm,
  VesselHotoFormDraftBody,
  VesselHotoFormSubmitBody,
  VesselHotoFormType,
  VesselHotoSetList,
} from '@app/domain/entities/vessel-hoto-form.entity';
import { VesselHotoFormRepository } from '@app/domain/repositories/vessel-hoto-form.repository';
import { map, Observable } from 'rxjs';
import { VesselHotoFormService } from '../api-clients/vessel-hoto-form.service';
import { mapVesselHotoElementTree } from '../mappers/vessel-hoto-form.mapper';

@Injectable()
export class VesselHotoFormRepositoryImpl implements VesselHotoFormRepository {
  constructor(private readonly _vesselHotoFormService: VesselHotoFormService) {}

  getForm(
    vesselActivityId: number,
    formType: VesselHotoFormType,
    setNo?: number | null
  ): Observable<VesselHotoForm> {
    return this._vesselHotoFormService
      .getForm(vesselActivityId, formType, setNo)
      .pipe(map(form => form && mapVesselHotoElementTree(form)));
  }

  getSets(vesselActivityId: number): Observable<VesselHotoSetList> {
    return this._vesselHotoFormService.getSets(vesselActivityId);
  }

  startNewSet(vesselActivityId: number): Observable<VesselHotoSetList> {
    return this._vesselHotoFormService.startNewSet(vesselActivityId);
  }

  submitForm(
    vesselActivityId: number,
    formType: VesselHotoFormType,
    body: VesselHotoFormSubmitBody
  ): Observable<void> {
    return this._vesselHotoFormService.submitForm(
      vesselActivityId,
      formType,
      body
    );
  }

  saveDraft(
    vesselActivityId: number,
    formType: VesselHotoFormType,
    body: VesselHotoFormDraftBody
  ): Observable<void> {
    return this._vesselHotoFormService.saveDraft(
      vesselActivityId,
      formType,
      body
    );
  }
}
